// src/pages/admin/dashboard/components/DashboardActivityCharts.js
import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  AreaChart,
  Area,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend
} from "recharts";

const DashboardActivityCharts = ({ auditionData, monthlyData }) => {
  return (
    <Row className="g-4 mb-4">
      {/* BAR */}
      <Col lg={6}>
        <Card className="dashboard-chart-card h-100">
          <Card.Body>
            <h5 className="chart-title mb-4">
              Weekly Auditions
            </h5>

            <ResponsiveContainer
              width="100%"
              height={300}
              className="dashboard-chart-container"
            >
              <BarChart data={auditionData}>
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#222"
                />

                <XAxis dataKey="name" />

                <YAxis />

                <Tooltip 
                  cursor={{ fill: 'rgba(255, 255, 255, 0.05)' }} 
                  contentStyle={{ backgroundColor: '#0f172a', borderColor: '#1e293b', borderRadius: '8px', color: '#fff' }} 
                />

                <Legend />

                <Bar
                  dataKey="auditions"
                  fill="#8B0000"
                  radius={[8, 8, 0, 0]}
                  barSize={70}
                />
              </BarChart>
            </ResponsiveContainer>
          </Card.Body>
        </Card>
      </Col>

      {/* LINE */}
      <Col lg={6}>
        <Card className="dashboard-chart-card h-100">
          <Card.Body>
            <h5 className="chart-title mb-4">
              User Activity
            </h5>

            <ResponsiveContainer
              width="100%"
              height={300}
            >
              <AreaChart data={monthlyData}>
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#222"
                />

                <XAxis dataKey="month" />

                <YAxis />

                <Tooltip 
                  cursor={{ fill: 'rgba(255, 255, 255, 0.05)' }} 
                  contentStyle={{ backgroundColor: '#0f172a', borderColor: '#1e293b', borderRadius: '8px', color: '#fff' }} 
                />

                <Legend />

                <defs>
                  <linearGradient
                    id="userGradient"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop
                      offset="5%"
                      stopColor="#DC143C"
                      stopOpacity={0.8}
                    />
                    <stop
                      offset="95%"
                      stopColor="#DC143C"
                      stopOpacity={0}
                    />
                  </linearGradient>
                </defs>

                <Area
                  type="monotone"
                  dataKey="users"
                  stroke="#DC143C"
                  fill="url(#userGradient)"
                  strokeWidth={4}
                />
              </AreaChart>
            </ResponsiveContainer>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default DashboardActivityCharts;
